import { render, staticRenderFns } from "./add-university.vue?vue&type=template&id=520586f4&scoped=true"
import script from "./add-university.vue?vue&type=script&lang=js"
export * from "./add-university.vue?vue&type=script&lang=js"
import style0 from "./add-university.vue?vue&type=style&index=0&id=520586f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520586f4",
  null
  
)

export default component.exports